<template>
  <div class="collection-grid__container">
    <div>
      <div class="collection-grid__layout">
        <collection-sidebar-b
          v-if="notMobileTablet && visibilitySettings.sidebarDisabled !== true"
          :default-sort="defaultSort"
          :filters-disabled="visibilitySettings.filtersDisabled"
          :tags="tags"
          :filters="filters"
        ></collection-sidebar-b>
        <div
          class="collection-grid__wrapper collection-grid__wrapper--sidebar"
          :class="[
            visibilitySettings.filtersDisabled === 1 &&
              'collection-grid__wrapper--filters-disabled'
          ]"
        >
          <portal-target class="collection__mobile-menu-portal-target" name="collection__mobile-menu" />
          <collection-grid-header-b
            :pagination-amount="paginationAmount"
            :total-pages="totalPages"
            :tags="tags"
            :filters="filters"
            :default-sort="defaultSort"
            :filtersDisabled="visibilitySettings.filtersDisabled"
            @changeGridColumns="changeGridColumns"
          ></collection-grid-header-b>

          <fade-transition
            key="grid"
            class="collection-grid no-promo-tile"
            v-if="this.fetchingStatus === false && this.currentTotal >= 1"
            :duration="{ enter: 800, leave: 200 }"
            :class="gridColumns"
            group
          >
            <div
              class="collection-grid-item"
              v-for="(product, index) in currentProducts"
              :key="`nopromo_${product.id}`"
            >
              <simple-product-tile
                :selected-variant="getCurrentFilteredVariant(product)"
                :showWishlist="wishlistEnabled"
                :show-mobile-ATC="true"
                :collection-handle="currentCollectionHandle"
                :collection-gender="collectionGender"
                :key="product.id"
                :product="product"
                :onAddToCart="addToCart"
                :style="`order: ${index}`"
                :pulled="pulled"
                collection-template="b"
                :collection="true"
              />
            </div>
          </fade-transition>

          <fade-transition :duration="{ enter: 600, leave: 200 }">
            <div
              class="collection-grid collection-grid__skeleton"
              v-if="this.fetchingStatus === true"
              key="skeleton"
            >
              <div
                class="collection-grid__skeleton-tile"
                v-for="n in paginationAmount"
                :key="`skel-${n}`"
              >
                <product-tile-skeleton></product-tile-skeleton>
              </div>
            </div>
          </fade-transition>
          <fade-transition :duration="{ enter: 600, leave: 200 }">
            <div
              class="collection-grid__no-results text-center"
              v-show="this.fetchingStatus === false && this.currentTotal === 0"
              key="noProducts"
            >
              <p>
                We couldn’t find any products using your currently selected
                filters.
              </p>
            </div>
          </fade-transition>
          <collection-grid-footer-b>
            <collection-pagination-controls-b
              v-show="this.fetchingStatus === false && this.currentTotal > 0"
              :initPages="totalPages"
              :pagination-amount="paginationAmount"
              :bottom-pagination="true"
            ></collection-pagination-controls-b>
          </collection-grid-footer-b>

       
    <div class="container" v-if=gridTheBrandSettings.text>
      <div  class="collection-hero collection-hero__brand-wrapper t-d">
        <div  class="collection-hero__text text-right">
          <div  class="collection-hero__brand">
            <h2  class="color-black h3">About {{initCollectionData.title}}</h2>
            <p  class="body-sm-mobile body-md-tablet-up color-black">{{gridTheBrandSettings.text}}</p>
         
          </div>
        </div>
        <div class="collection-hero__text collection-hero__content text-left">
          <img v-if="gridTheBrandSettings.imageUrl" :src="gridTheBrandSettings.imageUrl" alt="">
        </div>
      </div>
    </div>
          <div
            id="more-about-the-brand"
            class="collection-grid__about-brand"
            v-if="moreAboutTheBrandSettings.text"
          >
            <div class="collection-grid__about-brand-wrapper">
              <h3>More about {{initCollectionData.title}}</h3>
              <div
                class="collection-grid__about-brand-text"
                :class="{ 'collection-grid__about-brand-text--more' : addOverflowBrandClass }"
                ref="moreAboutBrand"
              >
                <div ref="moreAboutBrandText">
                  <p>{{moreAboutTheBrandSettings.text}}</p>
                </div>
              </div>
              <!-- <span
                class="link link--secondary"
                v-if="!hideShowMoreBrandButton"
                v-on:click="addOverflowBrandClass = !addOverflowBrandClass"
              >
                <span class="h7 link__content">
                  {{ addOverflowBrandClass ? 'Show Less' : 'Show More' }}
                </span>
              </span> -->
            </div>
          </div>
          <div id="additional-content" class="collection-grid__additional-content" v-if="additionalContents.text">
            <p v-html="additionalContents.text"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { FadeTransition } from 'vue2-transitions'

import { handleize, unhandleize } from '@/scripts/filters/string.js'

// import CollectionSections from './CollectionSections.vue'
import CollectionGridHeaderB from './CollectionGridHeaderB.vue'
import CollectionGridFooterB from './CollectionGridFooterB.vue'
import CollectionTotalResults from './CollectionTotalResults.vue'
import CollectionPaginationControlsB from './CollectionPaginationControlsB.vue'
import CollectionSidebarB from './CollectionSidebarB.vue'
// import CollectionPromoTile from './CollectionPromoTile.vue'
import CollectionActiveFiltersB from './CollectionActiveFiltersB.vue'
import CtaTile from './CtaTile.vue'
import SimpleProductTile from '@/scripts/components/product/ProductTileSimple.vue';
import ProductTileSkeleton from '@/scripts/components/product/ProductTileSkeleton.vue'
import SelectInput from '@/scripts/components/forms/SelectInput.vue'
import VButton from '@/scripts/components/buttons/VButton.vue'

import { sortProductsBy } from '@/scripts/helpers/sort.js'

export default {
  name: 'CollectionGridB',
  components: {
    CtaTile,
    SimpleProductTile,
    ProductTileSkeleton,
    SelectInput,
    CollectionSidebarB,
    CollectionGridHeaderB,
    CollectionGridFooterB,
    CollectionPaginationControlsB,
    CollectionTotalResults,
    CollectionActiveFiltersB,
    FadeTransition,
    VButton
    // CollectionPromoTile,
    // CollectionSections
  },
  props: {
    /**
     * Simulate a slight crop on tiles and increase their srcsets/sizes to match.
     */
    pulled: {
      type: Boolean,
      default: true,
    },
    wishlistEnabled: Boolean,
    handle: String,
    initCollectionData: Object,
    initCollectionTotal: Number,
    initCollectionProducts: Array,
    totalProducts: Number,
    paginationAmount: Number,
    collectionGender: String,
    tags: Array,
    filters: Array,
    campaignCollectionImages: {
      type: Object,
      default: () =>  ({
        desktopImageUrl: null,
        mobileImageUrl: null,
      })
    },
    gridTheBrandSettings: {
      type: Object,
      default: () => ({
        text: String,
        imageUrl: String,
        hasMoreBrandText: Boolean
      })
    },
    visibilitySettings: {
      type: Object,
      default: () => ({
        filtersDisabled: Number
      })
    },
    moreAboutTheBrandSettings: {
      type: Object,
      default: () => ({
        text: String
      })
    },
    additionalContents: {
      type: Object,
      default: () => ({
        text: String
      })
    }
  },
  data () {
    return {
      // Define a reversed data property
      addOverflowBrandClass: false,
      hideShowMoreBrandButton: false,
      gridColumns: ""
    }
  },
  computed: {
    ...mapState({
      fetchingStatus: state => state.collections.fetchingStatus,
      currentHandle: state => state.collections.currentHandle,
      currentPage: state => state.collections.currentPage,
      currentSort: state => state.collections.currentSort,
      currentFilters: state => state.collections.currentFilters,
      currentProducts: state => state.collections.currentProducts,
      currentTotal: state => state.collections.currentTotal
    }),
    totalPages () {
      return Math.ceil(this.currentTotal / this.paginationAmount)
    },
    notMobileTablet () {
      return this.$mq !== 'mobile' && this.$mq !== 'tablet'
    },
    firstRelevantFilter () {
      const relevant = this.currentFilters.find(
        filter => filter.includes('color') || filter.includes('pattern')
      )
      if (!relevant) {
        return ''
      }
      if (relevant.startsWith('color-')) {
        return relevant.split('color-')[1]
      }
      if (relevant.startsWith('pattern-')) {
        return relevant.split('pattern-')[1]
      }
    },
    defaultSort () {
      const data = this.initCollectionData
      return data && data.sort_order ? data.sort_order : 'best-selling';
    },
    currentCollectionHandle () {
      const data = this.initCollectionData
      return data && data.handle ? data.handle : 'all'
    }
  },
  methods: {
    campaignImageUrl() {
      return this.$mq === 'mobile'? this.campaignCollectionImages.mobileImageUrl:this.campaignCollectionImages.desktopImageUrl
    },
    addToCart (id) {
      const addProduct = {
        id: id,
        quantity: 1
      }
      this.$store
        .dispatch('cart/addItems', addProduct)
        .then(() => this.$store.dispatch('cart/afterAddToCart'))
        .catch(error =>
          this.$store.dispatch('toast/send', { text: error, type: 'error' })
        )
        .then(() => (this.adding = false))
    },
    getCurrentFilteredVariant (currentProduct) {
      if (this.firstRelevantFilter !== '') {
        const filteredVariant = currentProduct.variants.find(variant => {
          return variant.options.find(
            option => handleize(option) === this.firstRelevantFilter
          )
        })
        return filteredVariant || currentProduct.variants[0]
      }
      return currentProduct.variants[0]
    },
    initializeGrid() {
      const queryParams = new URLSearchParams(window.location.search);
      const page = queryParams.get('page');
      const sort = queryParams.get('sort_by');
      const pathArray = window.location.pathname.split('/');
      // Get filters from URL path
      // URL path structure is /collections/collection-handle/filters
      const currentFilters = pathArray.length > 3 && pathArray[3].length > 0 ? pathArray[3].split('+') : [];

      this.$store.dispatch('collections/setInitialCollectionState', {
        handle: this.currentCollectionHandle,
        products: this.initCollectionProducts,
        total: this.initCollectionTotal,
        sort: sort ? sort : this.defaultSort,
        tags: this.tags,
        currentFilters,
        page: page ? parseInt(page) : 1,
      }).then(() => {
        this.$store.dispatch('collections/fetchProducts')
      })
    },
    changeGridColumns (gridClass) {
      this.gridColumns = gridClass;
    }
  },
  mounted () {
    console.log('about log',this.gridTheBrandSettings)
    const { moreAboutBrand, moreAboutBrandText } = this.$refs;

    if (moreAboutBrand && moreAboutBrandText) {
      const moreAboutBrandHeight = moreAboutBrand.clientHeight;
      const moreAboutBrandTextHeight = moreAboutBrandText.clientHeight;

      if (moreAboutBrandTextHeight === moreAboutBrandHeight) {
        this.hideShowMoreBrandButton = true;
      }
    }
  },
  created () {
    this.initializeGrid();
    window.addEventListener('popstate', this.initializeGrid);
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.initializeGrid);
  }
}
</script>

<style scoped lang="scss">
.container {
  padding: 0 $grid-gutter;
  @include mobile-only {
    padding: 0;
  }
}

.collection-grid {
  position: relative;
  text-align: left;
  font-size: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: stretch;
  margin-right: -3px;

  @include mobile-tablet {
    margin: 0 -3px;
  }

  @include tablet-up {
    margin-right: -12px;

    /deep/ & .product-tile__images {
        height: 0;
        padding-top: 112.45%;
    }
  }

  &.justify-start {
    /deep/ .collection-promo-tile {
      display: none;
    }
  }

  &__skeleton {
    min-height: 100vh;
  }

  &__layout {
    display: flex;
  }

  &__wrapper {
    width: 100%;
    &--filters-disabled {
      max-width: 1127px;
      margin: 0 auto;
    }
    @include mobile-only {
      max-width: 375px;
      margin: 0 auto;
    }
  }

  &__header-pagination-controls {
    position: absolute;
    top: 4px;
    left: 0;
    display: flex;
  }

  &__filters {
    position: absolute;
    top: 4px;
    right: 0;
    border: none;
  }

  &__sort {
    &-wrapper {
      display: flex;
      justify-content: center;
      margin-bottom: 18px;

      @include tablet-up {
        justify-content: flex-end;
        margin-bottom: 36px;
      }
    }
  }

  &__loading {
    position: absolute;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  &__about-brand {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 80px;
    padding-bottom: 152px;
    @include mobile-only{
      padding-top: 0px;
    }
  }

  &__about-brand-wrapper {
    max-width: 90%;
    margin: auto;
    width: 100%;
    margin-left: 0px;

    @include mobile-only{
      margin-left: 20px;
      margin-top:20px;
    }

    h3 {
      margin-bottom: 20px;
      text-transform: none;
      font-size: 24px;
      letter-spacing: 0;
      line-height: 31px;
    }

    span.link {
      margin-top: 41px;
    }
  }

  &__about-brand-text {
    /* https://codepen.io/natonischuk/pen/KpNKQZ */
    /* hide text if it more than N lines  */
    // overflow: hidden;
    /* for set '...' in absolute position */
    position: relative;
    /* use this value to count block height */
    line-height: 25px;
    /* max-height = line-height (1.2) * lines max number (3) */
    // max-height: 150px;

    /* */
    margin-right: -1em;
    padding-right: 1em;
    &--more {
      max-height: 100%;
    }
  }
  &__additional-content {
    @include desktop-up {
      padding-right: 80px;
      margin-bottom: 50px;
    }
    @include mobile-tablet {
      margin: 0 15px;
    }
  }
}

.collection-grid-item {
  min-height: 340px;
  display: flex;
}

.collection-grid__wrapper--no-sidebar .collection-grid > * {
  margin-right: $collection-tile-side-margin-mobile;
  margin-bottom: 24px;
  width: 100%;
  display: inline-block;
  vertical-align: top;

  @include mobile-only {
    width: calc(50%);
    margin-right: 0;
    margin-bottom: 0;
  }

  @include tablet-only {
    width: calc(33%);
    margin-right: 0;
    margin-bottom: 0;
  }

  @include desktop-up {
    width: calc(25% - #{($collection-tile-side-margin-tablet * 3) / 4});
    margin-right: $collection-tile-side-margin-tablet;
    margin-bottom: 48px;

    &:nth-child(4n) {
      margin-right: 0;
    }
  }
}

.collection-grid__wrapper--sidebar .collection-grid > * {
  margin-right: $collection-tile-side-margin-mobile;
  width: 100%;
  display: inline-block;
  vertical-align: top;

  @include mobile-only {
    width: calc(50%);
    margin-right: 0;
    // margin-bottom: 43px;
    padding: 3px;
  }

  @include tablet-only {
    width: calc(33%);
    margin-right: 0;
    margin-bottom: 0;
    padding: 3px;
  }

  @include tablet-up {
    margin-bottom: 67px;
  }

  @include desktop-up {
    width: 33.3333%;
    padding-right: 12px;

    &:nth-child(3n) {
      margin-right: 0;
    }
  }
}

/deep/ .product-tile__mobile-image-button {
  display: none;
  top: 50%;
  transform: translateY(-50%);

  svg {
    fill: $color-black-400;
  }

  &--prev {
    left: 16px;
    transform: translateY(-50%) scaleX(-1);
  }

  &--next {
    right: 16px;
  }
}

.collection-grid-columns--1 {
  /deep/ .product-tile__mobile-image-button {
    display: block;
    z-index: 9;
    position: absolute;
  }

  /deep/ .product-tile__mobile-hovered {
    opacity: 1;
  }
}

.collection-grid__wrapper--sidebar {
  @include mobile-only {
    /deep/ & .product-tile__images {
        height: 0;
        padding-top: 112.5%;
    }
    .collection-grid-columns--1 > * {
      margin-right: $collection-tile-side-margin-mobile;
      margin-bottom: 24px;
      width: 100%;

      .product-tile {
        height: auto !important;
      }
    }

    .collection-grid-columns--2 {
      margin-right: -3px;
      > * {
        width: 50%;
        margin-right: 0;
        margin-bottom: 0;
        padding: 3px;
      }
    }
  }

  @include tablet-up {
    .collection-grid-columns--3 {
      margin-right: -12px;
      > * {
        width: 33.3333%;
        padding-right: 12px;
        margin-bottom: 48px;

        &:nth-child(3n) {
          margin-right: 0;
        }
      }
    }

    .collection-grid-columns--4 {
      margin-right: -3px;
      > * {
        width: 25%;
        margin-bottom: 0;
        padding: 3px;
      }
    }
  }
}

/deep/ .product-tile {
  .product-tile-vendor-name {
    color: $color-black-600;
    font-size: rem(11);
    margin-bottom: 6px;
    display: inline-block;
    white-space: normal;
  }

  &-title {
    color: $color-black-900;
    font-size: rem(14);
    margin-bottom: 6px;
    display: inline-block;

    @include tablet-up {
      font-size: rem(16);
    }
  }
  &__price {
    color: $color-black-900;
    display: inline-block;
    margin-bottom: 6px;
    @include tablet-up {
      font-size: rem(15);
    }
  }
  .pftm__review-stars-container {
    right: 8px;
    @include tablet-up {
      right: 16px;
    }
  }
  .icon--review-half-star, .icon--review-star {
    color: $color-black-600;
  }
  .yotpo-number-rating {
    width: auto;
    margin-left: 8px;
  }
}

.grid-sort-animation-move {
  transition: transform 0.5s cubic-bezier(0.77, 0, 0.175, 1);
}

.collection-grid__no-results {
  padding: 30px;
  padding-top: 0;

  @include tablet-up {
    padding: 0;
    padding-top: 132px;
    padding-bottom: 30px;
  }
}

.collection__mobile-menu-portal-target {
  position: sticky;
  top: 82px;
  z-index: 10;
  background: $color-white;
}
</style>


<style scoped lang="scss">
.container {
  padding: 0;
  margin-left:0px;
  background-color: transparent;
  @include mobile-only {
    padding: 0;
  }
}

.collection-hero__wrapper {
  padding: 0 32px;
  @include mobile-only {
    padding: 0 15px;
  }
}
.collection-hero__wrapper-campaign {
  padding: 0px;
  text-align: center;
}

.collection-hero {
  width: 100%;
  //min-height: 400px;
  display: flex;
  align-items:center;
  padding: 45px 0 45px;

  &__with-border {
    border-top: 1px solid #979391;
    border-bottom: 1px solid #979391;
    @include mobile-only {
      border-color: transparent;
    }
  }

  @include mobile-only {
    padding: 30px 0 30px;
    min-height: 0;
    //max-width: 344px;
    margin: 0 auto;
    display: block;
  }

  &__arrow {
    border: 1px solid #000000;
    height: 60px;
    width: 60px;
    border-radius: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
    @include mobile-only {
      margin-left: auto;
      margin-right: auto;
    }
  }

  &__with-image,
  &__no-image {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    @include mobile-only {
      flex-direction: column;
    }
    &-image {
      width: 54.19%;
      height: 352px;
      background-size: cover;
      background-position: center;
      @include mobile-only {
        width: 100%;
        height: 176px;
      }
    }
  }

  &__text {
    padding: 0 32px;
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left;
    @include mobile-only {
      padding: 0px 15px;
      width: 100%;
      text-align: left;
      min-height: 0;
    }
    img {
      align-self: center;
      max-width: 240px;
    }
    h1 {
      margin: auto;
      font-size: 52px;
      letter-spacing: 0;
      line-height: 1;
      font-family: "Ginkgo-Light";
      font-weight: 400;
      text-transform: none;
      padding-bottom: 10px;


      @include mobile-only {
        font-size: 28px;
      }
    }
    p {
      font-size: 15px;
      letter-spacing: -0.1px;
      line-height: 23px;

      //margin: 16px 0 0;
      @include mobile-only {
        //margin: 8px 0 0;
        margin: 0 auto;
      }
    }
  }

  &__header {
    @include mobile-only {
      padding-bottom: 12px;
      img {
        padding-bottom: 24px;
      }
    }
  }

  &__content {

  }

  &__brand-wrapper {
    padding-top: 75px;
    padding-bottom: 75px;
    align-items: center;
    img {
      max-width: 100%;
    }
    @include mobile-only {
      padding-top: 40px;
      padding-bottom: 0px;
    }

    .collection-hero__text {
      padding: 0;
    }
  }

  &__brand {
    max-width: 450px;

    margin-right: auto;
    @include mobile-only {
      padding-bottom: 42px;
      padding-left: 18px;
      padding-right: 18px;
      max-width: 356px;
    }

    h2 {
      font-size: 32px;
      letter-spacing: 0;
      line-height: 42px;
      text-transform: none;
      margin-bottom: 16px;
    }

    .button {
      margin-top: 24px;
    }
  }

  &__with-image {
    .collection-hero__text {
      @include tablet-up {
        padding-top: 0;
        padding-bottom: 0;
      }
    }
    &.align-left {
      flex-direction: row;
      @include mobile-only {
        flex-direction: column-reverse;
      }
    }
    &.align-right {
      flex-direction: row-reverse;
      @include mobile-only {
        flex-direction: column-reverse;
      }
    }
    &.overlaid {
      .collection-hero__text {
        box-shadow: 1px 2px 4px -1px rgba(0, 0, 0, 0.2);
        border-radius: 4px;

        @include mobile-only {
          padding: 24px 13px;
          width: 90%;
          text-align: right;
          margin-top: -64px;
          margin-bottom: 32px;
          z-index: 5;
          box-shadow: 1px 1px 2px -1px rgba(0, 0, 0, 0.2);
        }
      }
      .collection-hero__with-image-image {
        width: 80%;
        @include mobile-only {
          width: 100%;
        }
      }
      .collection-hero__text {
        @include tablet-up {
          padding: 32px;
          margin: 16px 0;
          z-index: 5;
        }
        
      }
      &.align-left {
        .collection-hero__text {
          @include tablet-up {
            margin-right: -128px;
          }
        }
      }
      &.align-right {
        .collection-hero__text {
          @include tablet-up {
            margin-left: -128px;
          }
        }
      }
    }
  }
  &__no-image {
    .text-right {
      margin: 0;
      text-align: right;
    }
  }
  &__quiz-container {
    padding: 0;
    margin: 30px 0 0 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    @include mobile-only {
      padding: 0;
      margin: 0 0 10px 0;
      width: 100%;
      display: block;
      justify-content: center;
      align-items: center;
      text-align: center;
    }
  }
}
.text-center {
  margin: 0 auto;
}
</style>
